// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"d374ed84","541":"95a8032c","570":"ea15f8eb","702":"b83d9778","914":"402f5bc6"}[chunkId] + ".chunk.js";
};